import { AfterViewInit, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements AfterViewInit, OnInit {
    roleMaster = [
        { label: "Seller", value: "seller" },
        { label: "Facilator", value: "broker" },
        { label: "Buyer", value: "buyer" },
    ];

    menu = [
        {
            href: "about-us", label: "About Us",
            submenu: [
                {
                    href: 'our-story',
                    label: "Our Story"
                }, {
                    href: 'our-vision',
                    label: "Our Vision"
                },
                {
                    href: 'how-it-works',
                    label: "How It Works"
                },
                {
                    href: 'people',
                    label: "People"
                }, {
                    href: 'infrastructure',
                    label: "Infrastructure"
                }, {
                    href: 'statistics',
                    label: "Statistics"
                }

            ]
        },
        {
            href: "services", label: "Our Services",

        },
        {
            href: "highlights", label: "Highlights",
            submenu: [{
                href: 'highlights',
                label: "Highlights"
            }, {
                href: 'timelines-or-road-map',
                label: "Timelines Or Road Map"
            }]
        },
        {
            href: "associates", label: "Associates",
            submenu: [
                {
                    href: 'registered-buyers',
                    label: "Registered Buyers"
                }, {
                    href: 'marks',
                    label: "Marks"
                }, {
                    href: 'organisational-associates',
                    label: "Organisational Associates"
                }, {
                    href: 'certifications',
                    label: "Certifications"
                }, {
                    href: 'supplier-associates',
                    label: "Supplier Associates"
                },
            ]
        },
        { href: "contact-us", label: "Contact Us" },

    ]

    loginSelectorForm: FormGroup;
    constructor(
        public authService: AuthService,
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
    ) {
        this.loginSelectorForm = this.formBuilder.group({
            'role': ['buyer', Validators.required]
        })
    }

    ngOnInit(): void {
        // this.router.events.pipe(
        //     filter(event => event instanceof NavigationEnd)
        //   ).subscribe(() => {
        //     const fragment = this.activatedRoute.snapshot.fragment;
        //     console.log(fragment);
        //     if (fragment) {
        //       // Scroll to the element with the specified fragment
        //       const element = document.getElementById(fragment);
        //       if (element) {
        //         element.scrollIntoView({ behavior: 'smooth' });
        //       }
        //     }
        //   });
    }
    ngAfterViewInit(): void {
        // this.scrollService.scroll();
    }

    loginClicked() {
        if (this.loginSelectorForm.valid) {
            this.router.navigate([`/${this.loginSelectorForm.value.role}/login`]);
            console.log(this.loginSelectorForm.value);
        }
    }


    classToggled = false;

    public toggleField() {
        this.classToggled = !this.classToggled;
    }
    redirectDashboard()
    {
    if(localStorage.getItem('disclaimer_text'))
    {
    localStorage.setItem('disclaimer_popup_open', '1');
    }
    this.router.navigateByUrl('dashboard');
    }
}
